import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'parks';

export function useGetAllParks(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetPark(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreatePark() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdatePark({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeletePark({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
